import {get} from "@/services/api";

const state = {
    evaluation: [],
    ratingAverage: 0
};

const getters = {
    getEvaluation: state => state.evaluation,
    getRatingAverage: state => {
        const ratingsArray = state.evaluation.map(e => e.rating)
        if (ratingsArray.length === 0) {
            return "0";
        }
        const sum = ratingsArray.reduce((a, b) => a + b, 0);
        const average = sum / ratingsArray.length;
        return (Math.round(average * 100) / 100).toFixed(1)
    }
}

const actions = {
    async fetchBySeminarId({commit},id){
        const response = await get(`gamification/evaluation/lesson/${id}`)
        commit('setEvaluation', response.data.items)
    },
    clear({commit}){
        commit('setEvaluation', [])
    }
}

const mutations = {
    setEvaluation: (state, evaluation) => (state.evaluation = evaluation),
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

